define('base/MbiLazySizes',[
	'jquery',
	'project/MbiConfig'
], function(
	$,
	mbiConfig
) {
	'use strict';

	// ----------------------------------------------------------------
	// LAZY SIZES CONFIG
	// ----------------------------------------------------------------

	window.lazySizesConfig = window.lazySizesConfig || {};

	window.lazySizesConfig.lazyClass = 			mbiConfig.lazysizes.lazyClass;
	window.lazySizesConfig.loadingClass = 		mbiConfig.lazysizes.loadingClass;
	window.lazySizesConfig.loadedClass = 		mbiConfig.lazysizes.loadedClass;
	window.lazySizesConfig.autosizesClass = 	mbiConfig.lazysizes.autosizesClass;
	window.lazySizesConfig.errorClass = 		mbiConfig.lazysizes.errorClass;
	window.lazySizesConfig.preloadClass = 		mbiConfig.lazysizes.preloadClass;

	require(['base/Vendor/LazySizes'], function() {

		mbiConfig.modules.MbiLazySizes = {
			'init': 	true,
			'version':	'2.0.0',

		};

	});

});
